import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { ApiEnvelope } from '../models/content.models';

export type TenantDashboardSummary = {
  usersCount: number;
  leadsCount: number;
  activeCounselors: number;
};

@Injectable({ providedIn: 'root' })
export class TenantDashboardService {
  constructor(private readonly api: ApiService) {}

  getSummary() {
    return this.api.get<ApiEnvelope<TenantDashboardSummary>>('tenant/dashboard').pipe(map((r) => r.data));
  }
}
